import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'
import isString from 'lodash/isString'
import isArray from 'lodash/isArray'
import map from 'lodash/map'
import cloneDeep from 'lodash/cloneDeep'
import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import isPlainObject from 'lodash/isPlainObject'

export function toCamelCaseDeep (object) {
  return convertCaseDeep(object, camelCase)
}

export function toCase (value, transformToCase) {
  return value.includes('.')
    ? value.split('.').map(transformToCase).join('.')
    : transformToCase(value)
}

export function toSnakeCaseDeep (object) {
  return convertCaseDeep(object, snakeCase)
}

function convertCaseDeep (object, transformPropertyName) {
  if (isString(object)) {
    return object
  }
  if (isArray(object)) {
    return map(object, obj => convertCaseDeep(obj, transformPropertyName))
  }

  let convertedObject = cloneDeep(object)

  // Convert keys to camel case
  convertedObject = mapKeys(
    convertedObject,
    (value, key) => toCase(key, transformPropertyName)
  )

  // Recursively apply throughout object
  return mapValues(
    convertedObject,
    value => {
      if (isPlainObject(value)) {
        return convertCaseDeep(value, transformPropertyName)
      } else if (isArray(value)) {
        return map(value, obj => convertCaseDeep(obj, transformPropertyName))
      }
      return value
    }
  )
}
